export default ({
  init: () => {
    const forms = document.querySelectorAll('.component.signup')
    const urlencodeFormData = fd => {
      let s = ''
      const encode = s => encodeURIComponent(s).replace(/%20/g,'+')
      for (var pair of fd.entries()) {
        if (typeof pair[1] == 'string'){
          s += (s?'&':'') + encode(pair[0]) + '=' + encode(pair[1]);
        }
      }

      return s;
    }

    forms.forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault()
        const error = form.querySelector('.error')
        const endpoint = form.dataset.endpoint

        form.classList.remove('has-error')
        error.textContent = ''

        fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          redirect: 'follow',
          body: urlencodeFormData(new FormData(form))
        })
          .then(response => response.json())
          .then(response => {
            if (response.resultCode == 'Success') {
              if (response.page.confirmationRedirectUrl) {
                window.location = response.page.confirmationRedirectUrl
              }
            } else {
              form.classList.add('has-error')
              error.textContent = 'An error occurred. Make sure you\'re using a valid email address, postal code, and phone number.'
            }
          })
          .catch(e => console.error(e))
        return false
      })
    })
  }
})
